module.exports = __webpack_public_path__ + "static/media/pt-serif-v18-cyrillic_cyrillic-ext_latin_latin-ext-italic.a8986663.woff2";